import type { SjzyRoute } from '@/types/router'
import { handleActivePath } from '@/utils/routes'

export function useTabs() {
  const route = useRoute()
  const tabsStore = useTabsStore()
  const { changeTabsMeta } = tabsStore

  /**
   * @description: 设置 tab 标题
   * @param {string} title
   * @param {SjzyRoute} tabRoute
   * @return {*}
   */
  const setTitle = (title: string, tabRoute = route) => {
    document.title = `${title} - CRM`
    if (!window.__MICRO_APP_ENVIRONMENT__) {
      changeTabsMeta({
        path: handleActivePath(tabRoute as SjzyRoute, true),
        meta: {
          title,
        },
      })
    }
    else {
      getMicroData().setTitle?.(title)
    }
  }

  return {
    setTitle,
  }
}
